import { map } from 'lodash';

const createCssTransition = (
    { speed = 300, easingFunction = 'ease', delay = 0 },
    property
) => `${property} ${speed}ms ${easingFunction} ${delay}ms`;

export const transition = (options, ...transitionProperties) => {
    const properties = [...transitionProperties];

    if (properties.length) {
        const transitions = map(properties, (property) =>
            createCssTransition(options, property)
        );

        return {
            transition: transitions.join(', ')
        };
    }

    return null;
};
